import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './router/permission'
import './styles/popup-menu.css'

// Element Plus
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import enLocale from 'element-plus/dist/locale/en.mjs'
import esLocale from 'element-plus/dist/locale/es.mjs'

// Vue I18n（从 i18n.js 引入，与 request.js 等共用同一实例，语言切换后接口提示才会同步）
import i18n from './i18n'
import { storageUtils } from './utils/storage'

const app = createApp(App)

// 获取Element Plus语言包
const getElementLocale = (locale) => {
  const localeMap = {
    'zh': zhCn,
    'en': enLocale,
    'es': esLocale
  }
  return localeMap[locale] || zhCn
}

// 注册Element Plus
app.use(ElementPlus, {
  locale: getElementLocale(storageUtils.getLanguage())
})

// 注册Element Plus图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 注册I18n
app.use(i18n)

// 注册路由和状态管理
app.use(router)
app.use(store)

app.mount('#app')